export const otherViewFilterText = "I0_x$c";
export default {otherViewFilterText};